/** "What they loved" — favourites with optional external links. */

export const LOVED_SECTION_TITLE = 'What they loved';
export const LOVED_SECTION_SUBTITLE =
  'Little things that made them them — songs, films, books, foods, places, and quiet passions.';

export const LOVED_CATEGORIES = [
  { id: 'song', label: 'Favourite songs', singular: 'Song' },
  { id: 'film', label: 'Favourite films', singular: 'Film' },
  { id: 'book', label: 'Favourite books', singular: 'Book' },
  { id: 'food', label: 'Favourite foods', singular: 'Food' },
  { id: 'place', label: 'Favourite places', singular: 'Place' },
  { id: 'hobby', label: 'Hobbies & pastimes', singular: 'Hobby' },
  { id: 'other', label: 'Other favourites', singular: 'Favourite' },
];

export function lovedCategoryLabel(categoryId) {
  return LOVED_CATEGORIES.find((c) => c.id === categoryId)?.label || 'Favourites';
}

export function lovedCategorySingular(categoryId) {
  return LOVED_CATEGORIES.find((c) => c.id === categoryId)?.singular || 'Favourite';
}

export function groupLovedItemsByCategory(items = []) {
  const groups = {};
  for (const cat of LOVED_CATEGORIES) {
    groups[cat.id] = [];
  }
  for (const item of items) {
    const key = groups[item.category] ? item.category : 'other';
    groups[key].push(item);
  }
  return LOVED_CATEGORIES.filter((c) => groups[c.id].length > 0).map((c) => ({
    ...c,
    items: groups[c.id],
  }));
}

export function blankLovedItem(category = 'song') {
  return {
    id: typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `tmp-${Date.now()}`,
    category,
    title: '',
    note: '',
    link_url: '',
    link_label: '',
  };
}

export function normalizeLovedItemDraft(raw) {
  const title = (raw.title || '').trim();
  if (!title) return null;
  const category = LOVED_CATEGORIES.some((c) => c.id === raw.category) ? raw.category : 'other';
  const note = (raw.note || '').trim();
  const link_url = (raw.link_url || '').trim();
  const link_label = (raw.link_label || '').trim();
  const entry = {
    id: raw.id || blankLovedItem(category).id,
    category,
    title,
  };
  if (note) entry.note = note;
  if (link_url && /^https?:\/\//i.test(link_url)) {
    entry.link_url = link_url;
    if (link_label) entry.link_label = link_label;
  }
  return entry;
}
